import { useLanguage } from '@/hooks/Contexts'
import { COUNTRY_LIST } from '@/utils/Consts'
import { ChangeEventHandler, FC, Fragment } from 'react'
import { UseFormReturn } from 'react-hook-form'
import validator from 'validator'
import { PhoneNumberInput, SearchBarDropdown, TextInput } from './FormElement'

const AddressLayout: FC<{
  onChange?: ChangeEventHandler<HTMLInputElement>
  form: UseFormReturn
  testidPrefix: string
}> = ({ onChange, form, testidPrefix }) => {
  const { user: userStr, errors: errStr } = useLanguage()
  const {
    register,
    formState: { errors },
    setValue,
    getValues,
  } = form

  return (
    <Fragment>
      <TextInput
        label={userStr.firstName}
        required={true}
        input={{
          'placeholder': userStr.firstName_placeholder,
          ...register('address.first_name', {
            required: userStr.firstName + errStr.required,
            validate: value => {
              if (value) return validator.isAlpha(value.replace(' ', '')) || errStr.name_invalid
            },
            onChange,
          }),
          // @ts-ignore
          'data-testid': `inp-${testidPrefix}-fstname`,
        }}
        showValidated={Boolean(errors?.address?.['first_name'])}
        valid={Boolean(!errors?.address?.['first_name'])}
        tipMessage={errors?.address?.['first_name']?.['message'] ?? null}
      />
      <TextInput
        label={userStr.lastName}
        required={true}
        input={{
          'placeholder': userStr.lastName_placeholder,
          ...register('address.last_name', {
            required: userStr.lastName + errStr.required,
            validate: value => {
              if (value) return validator.isAlpha(value.replace(' ', '')) || errStr.name_invalid
            },
            onChange,
          }),
          // @ts-ignore
          'data-testid': `inp-${testidPrefix}-lstname`,
        }}
        showValidated={Boolean(errors?.address?.['last_name'])}
        valid={Boolean(!errors?.address?.['last_name'])}
        tipMessage={errors?.address?.['last_name']?.['message'] ?? null}
      />
      <TextInput
        label={userStr.email}
        required={true}
        input={{
          'placeholder': userStr.email_placeholder2,
          ...register('address.email', {
            required: userStr.email + errStr.required,
            validate: value => {
              if (value) return validator.isEmail(value) || errStr.email_invalid
            },
            onChange,
          }),
          // @ts-ignore
          'data-testid': `inp-${testidPrefix}-email`,
        }}
        showValidated={Boolean(errors?.address?.['email'])}
        valid={Boolean(!errors?.address?.['email'])}
        tipMessage={errors?.address?.['email']?.['message'] ?? null}
      />
      {/* <TextInput
        label={userStr.phoneNum}
        required={true}
        input={{ ...register('address.phone', { required: userStr.phoneNum + errStr.required, onChange }) }}
        showValidated={Boolean(errors?.address?.['phone'])}
        valid={Boolean(!errors?.address?.['phone'])}
        tipMessage={errors?.address?.['phone']?.['message'] ?? null}
      /> */}
      {/* @ts-ignore */}
      <PhoneNumberInput isAddress={true} form={form} extraCls='' numberInputProps={{ 'data-testid': `${testidPrefix}-addr-phnumber` }} />
      <TextInput
        label={userStr.street}
        required={true}
        input={{
          'placeholder': userStr.street_placeholder,
          ...register('address.street', { required: userStr.street + errStr.required, onChange }),
          // @ts-ignore
          'data-testid': `inp-${testidPrefix}-st`,
        }}
        showValidated={Boolean(errors?.address?.['street'])}
        valid={Boolean(!errors?.address?.['street'])}
        tipMessage={errors?.address?.['street']?.['message'] ?? null}
      />
      <TextInput
        innerCls='md:mt-8'
        input={{
          'placeholder': userStr.street_optional,
          ...register('address.street_2', { onChange }),
          // @ts-ignore
          'data-testid': `inp-${testidPrefix}-aptmt`,
        }}
      />
      <TextInput
        label={userStr.city}
        required={true}
        input={{
          ...register('address.city', { required: userStr.city + errStr.required, onChange }),
          // @ts-ignore
          'data-testid': `inp-${testidPrefix}-city`,
        }}
        showValidated={Boolean(errors?.address?.['city'])}
        valid={Boolean(!errors?.address?.['city'])}
        tipMessage={errors?.address?.['city']?.['message'] ?? null}
      />
      {/* {getValues('address.country') === 'Republic of Ireland' ? (
        <SearchBarDropdown
          outerCls='mt-4'
          label={userStr.county}
          required
          innerCls={errors?.address?.['county'] ? '!border-error' : ''}
          defOptions={IE_COUNTY_LIST.map(county => county.name)}
          input={{
            type: 'text',
            placeholder: userStr.county + errStr.required,
            ...register('address.county', { required: userStr.county + errStr.required }),
            className: 'w-full cursor-pointer',
          }}
          onSelect={v => setValue('address.county', v, { shouldValidate: true, shouldDirty: true })}
        />
      ) : (
        <TextInput
          outerCls='mt-4'
          innerCls='mt-4 md:mt-0'
          label={userStr.county + ' ' + userStr.optional}
          input={{ placeholder: userStr.optional, ...register('address.county', { onChange, required: false }) }}
        />
      )} */}
      <TextInput
        label={getValues('address.country') === 'Republic of Ireland' ? userStr.eircode : userStr.postcode}
        required={getValues('address.country') === 'Republic of Ireland' ? false : true}
        input={{
          ...register('address.postcode', {
            required: getValues('address.country') === 'Republic of Ireland' ? false : userStr.postcode + errStr.required,
            validate: value => {
              if (value)
                return (
                  getValues('address.country') === 'Republic of Ireland' ||
                  validator.isPostalCode(value, 'GB') ||
                  validator.isPostalCode(value, 'IE') ||
                  errStr.postcode_invalid
                )
            },
            onChange,
          }),
          // @ts-ignore
          'data-testid': `inp-${testidPrefix}-pstcode`,
        }}
        showValidated={Boolean(errors?.address?.['postcode'])}
        valid={Boolean(!errors?.address?.['postcode'])}
        tipMessage={errors?.address?.['postcode']?.['message'] ?? null}
      />
      <SearchBarDropdown
        label={userStr.country}
        required
        defOptions={COUNTRY_LIST.map(country => country.name)}
        input={{
          'type': 'text',
          'placeholder': userStr.country_placeholder,
          ...register('address.country', { required: userStr.country + errStr.required }),
          'className': 'w-full cursor-pointer',
          // @ts-ignore
          'data-testid': `inp-${testidPrefix}-country`,
        }}
        onSelect={v => {
          setValue('address.country', v, { shouldValidate: true, shouldDirty: true })
          setValue('address.county', '', { shouldValidate: true, shouldDirty: true })
        }}
      />
    </Fragment>
  )
}

export default AddressLayout
